var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F44E(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    d: "M37.333 57.207l-1.667-4.583-3.916-9.584-.063-1.736h9.125l.854-.597.834-.667 13.166-.5 2.584-1.5-.167-3.416-1.167-2.167 2.5-1.167.917-2.75-1.917-2.666-1.583-.667 1.583-3-.833-2.333-1.333-1.667-3.584-.083.75-1.584-.75-3.833-2.395-1.57-14.042.208-9.625-.04-12.938 7.07-1.999 11.273L19 42.708 34.166 60.04l2.922.645z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.236 40.316c-3.2-3.576-4.98-8.2-5-13 0-8.319 5.679-15 14-15h9M17.236 40.316l15 19c2.21 2.8 5.811 1.084 5-1l-7-18h4.389M41.448 40.316h13a3.53 3.53 0 100-7h-13a3.786 3.786 0 00-4 3.5 3.786 3.786 0 004 3.5zM42.305 18.98h7a3.53 3.53 0 100-7h-7a3.786 3.786 0 00-4 3.5 3.786 3.786 0 004 3.5zM37.236 32.98h19a3.53 3.53 0 100-7h-19a3.786 3.786 0 00-4 3.5 3.786 3.786 0 004 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M39.236 25.98h15a3.53 3.53 0 100-7h-15a3.786 3.786 0 00-4 3.5 3.786 3.786 0 004 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M27.355 12.315c-10.5 0-15.125 6.94-15.125 15.5.08 2.717.73 5.388 1.906 7.839"
  }))));
}
export default Svg1F44E;